// extracted by mini-css-extract-plugin
module.exports = {"box":"HeadImage_box_3UvP8","head-image":"HeadImage_head-image_1OYNM","head-circle-image":"HeadImage_head-circle-image_3wusQ"};